import React, { useRef, useState } from "react";
import competencesData from "./populateCompetences";

import { FiLink2 } from "react-icons/fi";
import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
import { Competence, SubCompetence } from "../../shared/types";

type Props = {
  competence: Competence;
  setCompetence: (value: Competence) => void;
};

const CompetencesPage = ({ competence, setCompetence }: Props) => {
  const [selectedCompetence, setSelectedCompetence] = useState<number | null>(
    null
  );
  const [selectedItem, setSelectedItem] = useState<number | null>(null);

  const [selectedItemItem, setSelectedItemItem] = useState<number | null>(null);
  const [selectedItemUrlClick, setSelectedItemUrlClick] = useState<
    number | null
  >(null);

  const firstRef = useRef<HTMLDivElement>(null);
  const secondRef = useRef<HTMLDivElement>(null);
  const thirdRef = useRef<HTMLDivElement>(null);
  const fourthRef = useRef<HTMLDivElement>(null);

  const handleCompetenceClick = (competenceId: number) => {
    setSelectedCompetence(
      competenceId === selectedCompetence ? null : competenceId
    );

    window.scrollTo(0, 0);

    setSelectedItemItem(null);
    setSelectedItem(null); // Reset selected item when clicking on a new competence
    setSelectedItemUrlClick(null);
  };

  const handleItemClick = (itemId: number) => {
    setSelectedItem(itemId === selectedItem ? null : itemId);
    setSelectedItemItem(null);
    setSelectedItemUrlClick(null);
  };

  const handleItemItemClick = (itemID: number) => {
    setSelectedItemItem(itemID === selectedItemItem ? null : itemID);
    setSelectedItemUrlClick(null);
  };

  const handleItemUrlClick = (itemID: number) => {
    setSelectedItemUrlClick(itemID === selectedItemUrlClick ? null : itemID);
  };

  const renderCompetence = (competence: Competence) => {
    return (
      <div className="cursor-pointer ">
        <div
          className={`flex justify-center mb-4 text-4xl ${competence.color}`}
        >
          {competence.icon}
        </div>
        <h2 className="text-xl text-center font-bold mb-2">
          {competence.title}
        </h2>
        {(!selectedCompetence || selectedCompetence !== competence.id) && (
          <p className="text-gray-950 text-center" ref={firstRef}>
            {competence.shortDescription}
          </p>
        )}
      </div>
    );
  };

  return (
    <div className="bg-gray-100 w-full h-full sm:h-full pb-8 2xl:h-full 2xl:py-40 flex flex-col justify-center items-center lg:px-0 px-4">
      <div className="container mx-auto text-center mb-8">
        <h1 className="2xl:text-7xl  lg:text-6xl   font-bold text-4xl mt-24 text-center  text-palette1 mb-6 lg:mb-6">
          Our Competences
        </h1>
        <p className="text-gray-950 2xl:text-4xl lg:text-xl ">
          Discover our areas of expertise and capabilities
        </p>
      </div>
      <div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-5 gap-8">
        {competencesData.map((competence) => (
          <div
            key={competence.id}
            className={`bg-white p-6 rounded-md shadow-lg transition duration-300 transform hover:-translate-y-2 hover:shadow-xl ${
              selectedCompetence && selectedCompetence == competence.id
                ? "col-span-full order-first"
                : ""
            }`}
          >
            {competence.items.length > 0 ? (
              <NavLink
                to={`/competence/`}
                onClick={() => {
                  setCompetence(competence);
                }}
              >
                {renderCompetence(competence)}
              </NavLink>
            ) : (
              renderCompetence(competence)
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompetencesPage;
